const LoadingSpinner = () => {
	return (
		<div>
			<svg
				className="w-20 h-20 animate-spin text-navy"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 100 100"
				preserveAspectRatio="xMidYMid">
				<circle
					cx="50"
					cy="50"
					r="32"
					strokeWidth="8"
					stroke="currentColor"
					strokeDasharray="50.26548245743669 50.26548245743669"
					fill="none"
					strokeLinecap="round"></circle>
			</svg>
		</div>
	);
};

export default LoadingSpinner;
